<template>
    <div class="w-full flex justify-end py-2 px-1">
        <button 
            class="border-2 border-gray px-2 mr-1 rounded-lg cursor-pointer"
            :class="prevPageUrl === null || prevPageUrl === '' ? 'opacity-40' : ''"
            @click="$emit('prevPage', prevPageUrl)"
        >
            <
        </button>
        <button 
            class="border-2 border-gray px-2 ml-1 rounded-lg cursor-pointer"
            :class="nextPageUrl === null || nextPageUrl === '' ? 'opacity-40' : ''"
            @click="$emit('nextPage', nextPageUrl)"
        >
            >
        </button>
    </div>
</template>

<script>
export default {
    props: {
        nextPageUrl: {
            type: String,
            required: true
        },

        prevPageUrl: {
            type: String,
            required: true
        },
    }
}
</script>